import {
  addNewCrewEmployeeApi,
  deleteCrewEmployeeApi,
  getAllCrewEmployeesApi,
  editCrewEmployeeApi
} from "../../apis/crewEmployee";

import {
  getAllCrewEmployeeFail,
  getAllCrewEmployeeSuccess,
  addNewCrewEmployeeFail,
  addNewCrewEmployeeSuccess,
  editExistingCrewEmployeeFail,
  editExistingCrewEmployeeSuccess,
  deleteExistingCrewEmployeeFail,
  deleteExistingCrewEmployeeSuccess
} from "../constants/crewEmployee";

import { showNotification } from "./notification";

// Action Creators
export const getAllCrewEmployeesSuccess = (res) => ({
  type: getAllCrewEmployeeSuccess,
  payload: res,
});

export const getAllCrewEmployeesFail = () => ({
  type: getAllCrewEmployeeFail,
});

export const addNewCrewMemberSuccess = (payload) => ({
  type: addNewCrewEmployeeSuccess,
  payload,
});

export const addNewCrewMemberFail = () => ({
  type: addNewCrewEmployeeFail,
});

export const editExistingCrewEmployee = (payload) => ({
  type: editExistingCrewEmployeeSuccess,
  payload,
});

export const editExistingSupervisorError = () => ({
  type: editExistingCrewEmployeeFail,
});

export const deleteCrewMemberSuccess = (id) => ({
  type: deleteExistingCrewEmployeeSuccess,
  payload: id,
});

export const deleteCrewMemberFail = () => ({
  type: deleteExistingCrewEmployeeFail,
});

// Thunks
export const getAllEmployee = (query) => {
  return (dispatch) => {
    getAllCrewEmployeesApi(query).then(
      (res) => {
        dispatch(getAllCrewEmployeesSuccess(res));
      },
      (error) => {
        dispatch(getAllCrewEmployeesFail());
        dispatch(showNotification({
          type: 'error',
          message: 'Failure',
          description: error?.message || 'Failed to fetch crew employees',
        }));
      }
    );
  };
};

export const addNewCrewMember = (payload, onSuccess) => {
  return (dispatch) => {
    addNewCrewEmployeeApi(payload).then(
      (res) => {
        dispatch(addNewCrewMemberSuccess(res));
        dispatch(showNotification({
          type: 'success',
          message: 'Success',
          description: 'New Employee Added Successfully',
        }));
        if (onSuccess) onSuccess();
      },
      (error) => {
        dispatch(addNewCrewMemberFail());
        dispatch(showNotification({
          type: 'error',
          message: 'Failure',
          description: error?.message || 'Failed to add employee',
        }));
      }
    );
  };
};

export const editCrewMember = (payload) => {
  return (dispatch) => {
    editCrewEmployeeApi(payload).then(
      (res) => {
        dispatch(editExistingCrewEmployee(res));
        dispatch(showNotification({
          type: 'success',
          message: 'Success',
          description: 'User Data Updated Successfully',
        }));
      },
      (error) => {
        dispatch(editExistingSupervisorError());
        dispatch(showNotification({
          type: 'error',
          message: 'Failure',
          description: error?.message || 'Failed to update employee',
        }));
      }
    );
  };
};

export const deleteCrewMember = (id) => {
  return (dispatch) => {
    deleteCrewEmployeeApi(id).then(
      () => {
        dispatch(deleteCrewMemberSuccess(id));
        dispatch(showNotification({
          type: 'success',
          message: 'Success',
          description: 'User Data Deleted Successfully',
        }));
      },
      (error) => {
        dispatch(deleteCrewMemberFail());
        dispatch(showNotification({
          type: 'error',
          message: 'Failure',
          description: error?.message || 'Failed to delete employee',
        }));
      }
    );
  };
};
